export const instagramUrl = 'https://www.instagram.com/simonehomeandgarden/';
export const toolbarMd = '50px';
export const toolbarLg = '62px';